import React from "react";
import Parse from "parse";

type Result<T> = {
  result: T | undefined;
  loading: boolean;
  error: Error | undefined;
  reload: () => void;
};

export function useParseFunction<T>(
  name: string,
  params: any,
  dependency?: any
): Result<T> {
  const [state, setState] = React.useState({
    result: undefined,
    loading: true,
    error: undefined,
    reload: fetch,
  });

  async function fetch() {
    if (!name) {
      return;
    }

    Parse.Cloud.run(name, params).then(
      (response) => {
        setState({
          result: response,
          error: undefined,
          loading: false,
          reload: fetch,
        });
      },
      (error) => {
        setState({
          result: undefined,
          error,
          loading: false,
          reload: fetch,
        });
      }
    );
  }

  React.useEffect(() => {
    setState({
      result: undefined,
      loading: true,
      error: undefined,
      reload: fetch,
    });

    fetch();
  }, [name, dependency]);

  return state;
}
